if ($('.js-regions').length > 0) {
  const container = $('.js-regions');

  $('.js-regions-link').each(function() {
    $(this).on('click', function(evt) {
      evt.preventDefault();

      $('.js-regions-item').removeClass('regions__item_active');
      $('.js-regions-point').removeClass('active');
      $('.js-regions-tooltip').removeClass('active');
      $('.js-regions-tooltip-text').removeClass('active');

      const target = $(this).attr('href');
      $(this).parent('.regions__item').addClass('regions__item_active');

      const tooltip = $(container).find(`${target}`);

      $(tooltip).addClass('active');
    })
  })
}
